import { useState, useContext, useMemo } from 'react';
import { currencyFormat, i18nValue } from "../../functions";
import UpSellingCardDetail from './UpSellingCardDetail';
import { CheckInContext } from "../../context/checkin";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheckCircle, faImage } from "@fortawesome/free-solid-svg-icons";
import { getCDNImage } from '../../globals';
import { T } from "react-translator-component";
import { TagsIcon1, TagsIcon2 } from '../../components/Icons';
import { HotelContext } from '../../context/hotel';
import { NavLink } from 'react-router-dom';
import Tag from './Tag';
import processHtml from '../../components/processHtml';
import { hasBaremo, shouldHidePrice, getFromPriceLabel } from './upSellingUtils';

const UpSellingCard = ({ cup, cart, lang, addToCart, removeFromCart, currency, path }) => {
    const { crossUpSelling } = useContext(CheckInContext).data;
    const [show, setShow] = useState(false);
    const [isEditing, setIsEditing] = useState(false);
    const { data: hotel } = useContext(HotelContext);

    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleEdit = () => {
        setIsEditing(true);
        setShow(true);
    }

    const inCart = useMemo(() => {
        if (!cart) return false
        return cart[cup.id] !== undefined;
    }, [cart, cup.id]);

    const price = useMemo(() => {

        let auxPrice = cup.price;
        // Si existe en carro muestro el precio real (el seleccionado)
        if (cart?.[cup.id]) {
            if (cart[cup.id].optionSelected) {
                auxPrice = cart[cup.id].optionSelected.price;
            }
        }

        let auxPriceIsPerNight = cup.priceIsPerNight;
        if (cup.extra) {
            try {
                const extra = typeof cup.extra === "string" ? JSON.parse(cup.extra) : cup.extra;
                if (extra?.total != null) {
                    auxPrice = extra.total;
                    auxPriceIsPerNight = null;
                }
            } catch (_) {}
        }
        
        // ✅ type "option" / "options" (API puede enviar singular): mostrar "Desde" + precio (mínimo de options si existe, si no cup.price para listado)
        let priceLabel = "";
        const isOptionType = cup.type === "option" || cup.type === "options";
        if (isOptionType && !inCart) {
            priceLabel = getFromPriceLabel() + " ";
            if (cup.options && cup.options.length > 1) {
                auxPrice = Math.min(...cup.options.map(opt => opt.price ?? 0));
            }
        }

        if (auxPrice === 0) {
            if (shouldHidePrice(cup)) {
                return null;
            }
            return (
                <span className="general-text text-success">
                    <b>{T("general.no-charge")}</b>
                </span>
            )

        } else {
            return (
                <>
                    {priceLabel && <span style={{ fontSize: '12px', marginRight: '4px', fontWeight: '400' }}>{priceLabel}</span>}
                    {currencyFormat(auxPrice, currency)}
                    <span style={{ fontSize: '12px' }}>
                        {auxPriceIsPerNight && " - " + T('cups.priceIsPerNight')}
                    </span>
                </>
            )
        }

        return "--";

    }, [cup, inCart, cart]);

    const renderContent = useMemo(() => (
        <>
            <div className='d-flex align-items-center cross-up-selling-item-main'>
                {inCart && (
                    <div className='cross-up-selling-item-in-cart' style={{ position: 'absolute', top: 0, right: 0 }}>
                        <FontAwesomeIcon icon={faCheckCircle} className="mr-1" />{" "}{T('general.selected')}
                    </div>
                )}
                {cup.tags && cup.tags.length > 0 && (
                    <div className='cross-up-selling-item-tags'>
                        {cup.tags.map((tag, index) => (
                            <Tag text={T(`cups.tags.${tag}`)} key={index} />
                        ))}
                    </div>
                )}

                {cup.photo ? (
                    <img className='w-100' style={{ objectFit: 'cover' }} src={getCDNImage(cup.photo)} />
                ) : (
                    <div className='w-100 d-flex justify-content-center align-items-center' style={{ backgroundColor: '#C9C9C9', height: 190 }}>
                        <FontAwesomeIcon icon={faImage} style={{ color: 'white', fontSize: '110px', marginTop: '-20px' }} />
                    </div>
                )}

                <div className='cross-up-selling-item-title'>
                    <span>
                        {i18nValue(cup, 'title', lang)}
                    </span>
                </div>
            </div>            
            {
                cup.optionSelected
                    ?
                    <div class="d-flex justify-content-between" style="background: rgb(238, 238, 238); padding: 6px 13px; margin-top: 8px; border-radius: 8px;">
                        <b>{cup.optionSelected.name}</b>
                        <span>{currencyFormat(cup.optionSelected.price, currency)}</span>
                    </div>
                    :
                    <div>
                        <span className={`d-flex align-items-center cross-up-selling-item-price text-right ${inCart && 'cross-up-selling-item-in-cart'}`}>
                            {price}
                            {/* {cup.price === 0 ? (
                                <span className="general-text text-success">
                                    <b>{T("general.no-charge")}</b>
                                </span>
                            ) : (
                                <>
                                    <div>{cup.extra}</div>
                                    {currencyFormat(cup.price, currency)}
                                    <span style={{ fontSize: '12px' }}>
                                        {cup.priceIsPerNight && " - " + T('cups.priceIsPerNight')}
                                    </span>
                                </>
                            )} */}
                        </span>
                        {cup.priceOutOfOffer > 0 && (
                            <span className='cross-up-selling-item-price mr-0' id={cup.id} style={{ textDecoration: 'line-through', fontSize: '14px' }}>
                                {currencyFormat(cup.priceOutOfOffer, currency)}
                            </span>
                        )}
                    </div>

            }
            <p className='cross-up-selling-description'>{processHtml(i18nValue(cup, 'description', lang))}</p>
        </>
    ), [cup, inCart, currency, lang]);

    return (
        <>
            {path && path !== "request-detail" ? (
                <NavLink
                    className="mb-2 d-block text-decoration-none"
                    to={{
                        pathname: `/${hotel.code}/upselling/${cup.id}`,
                    }}
                    state={{ from: path }}
                    key={cup.id}
                >
                    <div className='cross-up-selling-item mb-3 shadow'>
                        {renderContent}
                    </div>
                </NavLink>
            ) : (
                <div onClick={handleShow} className='cross-up-selling-item mb-3 shadow'>
                    {renderContent}
                </div>
            )}

            {(!path || path === "request-detail") && <UpSellingCardDetail
                handleClose={handleClose}
                show={show}
                cup={cup}
                isEditing={isEditing}
                setIsEditing={setIsEditing}
                inCart={inCart}
                lang={lang}
                addToCart={addToCart}
                removeFromCart={removeFromCart}
                currency={currency}
                path={path}
            />}
        </>
    );
}

export default UpSellingCard;
